import React, { useEffect, useRef, useState } from "react";

import "./index.less";

const ShadowScroll = ({ children, verticalAlign, showScrollBar, containerClassName, ...props }) => {
  const wrapperRef = useRef();
  const [overflow, setOverflow] = useState(false);
  const [showLeftShadow, setShowLeftShadow] = useState(false);
  const [showRightShadow, setShowRightShadow] = useState(false);
  const [shoTopShadow, setShowTopShadow] = useState(false);
  const [showBottomShadow, setShowBottomShadow] = useState(false);

  const showHideShadow = () => {
    if (verticalAlign) {
      const isDownScrolled =  Math.ceil(wrapperRef?.current?.scrollTop) + wrapperRef?.current?.offsetHeight >
      wrapperRef?.current?.scrollHeight;
      const difference = isDownScrolled
          ? (
              Math.ceil(wrapperRef?.current?.scrollTop) +
              wrapperRef?.current?.offsetHeight -
              wrapperRef?.current?.scrollHeight
            )
          : (
            wrapperRef?.current?.scrollHeight -
            (Math.ceil(wrapperRef?.current?.scrollTop) + wrapperRef?.current?.offsetHeight) 
          );
      if (wrapperRef?.current.scrollHeight > wrapperRef?.current.clientHeight) {
        setOverflow(true);
        if (wrapperRef?.current.scrollTop > 10) {
          setShowTopShadow(true);
        } else {
          setShowTopShadow(false);
        }
        if (difference > 1) {
          setShowBottomShadow(true);
        } else {
          setShowBottomShadow(false);
        }
      } else {
        setOverflow(false);
      }
    } else if (wrapperRef?.current.scrollWidth > wrapperRef?.current.clientWidth) {
      setOverflow(true);
      if (wrapperRef?.current.scrollLeft > 10) {
        setShowLeftShadow(true);
        if (
          wrapperRef?.current.scrollLeft + wrapperRef?.current.offsetWidth ===
          wrapperRef?.current.scrollWidth
        ) {
          setShowRightShadow(true);
        } else {
          setShowRightShadow(false);
        }
      } else {
        setShowLeftShadow(false);
      }
    } else {
      setOverflow(false);
    }
  };

  useEffect(() => {
    showHideShadow();
  }, [children]);

  return (
    <div
      ref={wrapperRef}
      onScroll={showHideShadow}
      className={`shadow-scroll-wrapper ${containerClassName} ${!showScrollBar ? "hide-scroll-bar" : ""} ${overflow ? "overflow" : ""}`}
      {...props}
    >
      {showLeftShadow && !verticalAlign && <div className="left-shadow" />}
      {shoTopShadow && verticalAlign && <div className="top-shadow" />}
      {children}
      {!showRightShadow && !verticalAlign && <div className="right-shadow" />}
      {showBottomShadow && verticalAlign && <div className="bottom-shadow" />}
    </div>
  );
};

ShadowScroll.defaultProps = {
  showScrollBar: false,
};

export default ShadowScroll;
